import axios from "axios";

export const getContractUsageRules = async () => {
  const url = `${window.env.EJ_APPS_API_HOSTNAME}/e6t/v1/contract/usage_rules/latest/`;
  const response = await axios.get(url);
  return response.data;
};

export const getPrivacyPolicy = async () => {
  /* testten veri dönmüyor. kontrol edilecek */
  const url = `https://api.emlakjet.com/contract-templates/membership/latest`;
  const response = await axios.get(url);
  return response.data;
};

export const getKvkkContent = async () => {
  /* testten veri dönmüyor. kontrol edilecek */
  const url = `https://api.emlakjet.com/contract-templates/individualKvkk/latest`;
  const response = await axios.get(url);
  return response.data;
};

export const getExplicitConsent = async () => {
  /* testten veri dönmüyor. kontrol edilecek */
  const url = `https://api.emlakjet.com/contract-templates/explicitConsent/latest`;
  const response = await axios.get(url);
  return response.data;
};

export const getContract = async (type) => {
  const url = `https://api.emlakjet.com/e6t/v1/kvkk/application/desktop-web/form/${type}/contract`;
  const response = await axios.get(url);
  return response.data;
};

export const getCreditContracts = async () => {
  const url = `https://api.emlakjet.com/credit-api/v1/contracts/application/mobile-web/form/calculate_house_credit/contract`;
  const response = await axios.get(url);
  return response.data;
};
